export interface BlacklistRequest {
  limit: number;
  page: number;

  msisdnLike?: string;
  dateFrom?: Date;
  dateTo?: Date;
  orderColumn?: string;
  direction?: string;
}

export interface Blacklist {
  expanded?: boolean;
  additional?: Blacklist[];

  msisdn: string;
  username: string;
  eventDate: Date;
  status: string;
  sameMsisdnEventsCount: number;
}

export enum ImportAction {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export interface ImportFile {
  fileForm: FormData;
  action: ImportAction;
}
